import { Controller } from "@hotwired/stimulus";
import KeenSlider from "keen-slider";
import type { KeenSliderInstance } from "keen-slider";

export default class extends Controller<HTMLImageElement> {
  slider: KeenSliderInstance | null = null;

  connect() {
    document.addEventListener("turbo:before-cache", this.reset);
    this.slider = new KeenSlider(this.element);
    this.element.addEventListener("click", this.next);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset);
    this.element.removeEventListener("click", this.next);
    this.slider?.destroy();
    this.slider = null;
  }

  next = () => {
    this.slider?.next();
  };

  reset = () => {
    this.slider?.destroy();
    this.slider = null;
  };
}
